export const isDev = () => import.meta.env.MODE === 'development'
